module.exports = __webpack_public_path__ + "img/gaku_btn_08.cc0f045b.png";